export default {
  UPDATE: 'VOD.UPLOADING.PROGRESS.UPDATE',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/uploading-progress.js